/**
 * Where the statistics dashboard lives, and the segments beneath it.
 *
 * The domain sits under the queue application at `/queue/statistics` rather than
 * owning the site root. `/` redirects here (see `app.routes.ts`), so the dashboard
 * is still what the application opens on — but it is reachable by a path that says
 * what it is, and it no longer needs an empty-path parent sitting in front of every
 * other section's URL.
 *
 * Shared between the route definitions, the tab config and the layout's active-tab
 * derivation, so the three can never drift apart.
 */
export const QUEUE_STATISTICS_BASE = "/queue/statistics";

/**
 * The base as segments, for matching against a URL's own.
 *
 * The layout reads the tab from the URL, so it has to know how many leading
 * segments belong to the mount point rather than to a page.
 */
export const QUEUE_STATISTICS_BASE_SEGMENTS = QUEUE_STATISTICS_BASE.split("/").filter(Boolean);

/**
 * URL segments for the pages, relative to the base.
 *
 * The overview is the empty segment: it is the dashboard's landing page, so it owns
 * the base path itself rather than living behind a path of its own.
 */
export const QUEUE_STATISTICS_PATHS = {
  OVERVIEW: "",
  BRANCH_COMPARISON: "branch-comparison",
  EMPLOYEE_PERFORMANCE: "employee-performance",
} as const;

/** Absolute `routerLink` targets for the tab bar. */
export const QUEUE_STATISTICS_LINKS = {
  OVERVIEW: QUEUE_STATISTICS_BASE,
  BRANCH_COMPARISON: `${QUEUE_STATISTICS_BASE}/${QUEUE_STATISTICS_PATHS.BRANCH_COMPARISON}`,
  EMPLOYEE_PERFORMANCE: `${QUEUE_STATISTICS_BASE}/${QUEUE_STATISTICS_PATHS.EMPLOYEE_PERFORMANCE}`,
} as const;
